import { useQuery } from '@tanstack/react-query';
import { resumenDashboard } from '../lib/api/dashboard';
import { qk } from './keys';

export function useDashboard() {
  return useQuery({ queryKey: qk.dashboard, queryFn: resumenDashboard });
}
